<script>
export default {
  name: 'form-helpers',
  methods: {
    clearError (fieldName) {
      let pos = this.errors.indexOf(fieldName);

      if (pos > -1) {
        this.errors.splice(pos, 1);
      }
    },
    clearErrors (fieldNames) {
      let fields = fieldNames.split(',');

      for (let i = 0; i < fields.length; i++) {
        this.clearError(fields[i]);
      }
    },
    handleInvalidFields () {
      if (!this.errors || !this.errors.length) {
        return;
      }

      this.$nextTick(() => {
        let firstInvalidField = this.getFirstVisibleInvalidField();

        if (firstInvalidField) {
          firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (window.bugsnagClient) {
          let fields = this.errors.join(', ');

          window.bugsnagClient.notify(new Error('[Handled] Hidden field validation error: ' + this.$options.name), event => {
            event.addMetadata('form', { fields });
          });
        }
      });
    },
    getFirstVisibleInvalidField () {
      if (!this.$el || !this.$el.querySelectorAll) {
        return null;
      }

      let invalidFields = this.$el.querySelectorAll('.is-invalid, .is-error');

      for (let i = 0; i < invalidFields.length; i++) {
        if (invalidFields[i].offsetParent !== null) {
          return invalidFields[i];
        }
      }

      return null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/FormHelpers.vue